import ModalAlert from "../../../common/ModalAlert";
import { AlertsState } from "../../../features/alerts/alertsSlice";

export default (props:AlertsState) => {
    return <ModalAlert alert={props.alerts[props.alerts.length-1]}/> 
}